export default "__VITE_ASSET__DphchPr___"